import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class ReturnedOnColumn extends Column {
    title = 'table.assets.dateReturnedColumn';
    property = 'returnedOn';
    sortable = false;
    type: CellDisplay = CellDisplay.date;
}
